<template>
  <div class="scence usercenterUnusualDataReport">
    <div class="content">
      <div class="skt" ref="skt">
        <div class="select">
            <span id="export" @click="exportExcel">
            <span class="export-icon"></span>导出
          </span>
          <span id="setWater" @click="onConfigWater(1)"
            ><span class="setWater-icon"></span>水位值设置</span>
           <span
            id="setRain" @click="onConfigRain(2)"
            ><span class="setRain-icon"></span>雨量值设置</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table
              :data="tdata"
              border
              fit
              highlight-current-row
              :max-height="height"
              @row-click="clickRow"
              @selection-change="handleSelectionChange"
              style="width: 100%"
            >
             <!-- <el-table-column type="selection" min-width="40" align="center">
              </el-table-column> -->
              <el-table-column
                type="index"
                width="80"
                align="center"
                label="序号"
              ></el-table-column>
              <el-table-column
                align="center"
                label="站码"
                prop="sCode"
              ></el-table-column>
              <el-table-column
                align="center"
                label="站名"
                prop="sName"
              ></el-table-column>
              <el-table-column
                align="center"
                label="时间"
                prop="time"
              ></el-table-column>
               <el-table-column
                align="center"
                label="水位"
                prop="water"
              ></el-table-column>
              <el-table-column
                align="center"
                label="雨量"
                prop="rain"
              ></el-table-column>
              <el-table-column
                align="center"
                label="监测类型"
                prop="type"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 水位设置 -->
        <el-dialog
          :title="diagTitleWater"
          :visible.sync="diagShowWater"
          :close-on-click-modal="false"
          width="35%"
        >
          <el-form
            ref="waterForm"
            :rules="waterRules"
            :model="waterForm"
            label-width="100px"
          >
            <div class="formContent">
                <el-form-item label="水位值" required prop="waterValue">
                  <el-input
                    v-model="waterForm.waterValue"
                    placeholder="请输入水位值"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="描述">
                  <el-input
                    v-model="waterForm.desc"
                    placeholder="水位值描述信息"
                  ></el-input>
                </el-form-item> -->
            </div>
            <span style="color:red;display:block;margin-left:1.3rem;">注：该水位值表示用户设置5分钟水位超过该值为异常数据。</span>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="diagShowWater = false">取消</el-button>
            <el-button type="primary" @click="onSaveWater">保存</el-button>
          </div>
        </el-dialog>
        <!-- 雨量值设置 -->
        <el-dialog
          :title="diagTitleRain"
          :visible.sync="diagShowRain"
          :close-on-click-modal="false"
          width="35%"
        >
          <el-form
            ref="rainForm"
            :rules="rainRules"
            :model="rainForm"
            label-width="100px"
          >
            <div class="formContent">
                <el-form-item label="雨量值" required prop="rainValue">
                  <el-input
                    v-model="rainForm.rainValue"
                    placeholder="请输入雨量值"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="描述">
                  <el-input
                    v-model="rainForm.desc"
                    placeholder="雨量值描述信息"
                  ></el-input>
                </el-form-item> -->
            </div>
            <span style="color:red;display:block;margin-left:1.3rem;">注：该雨量值表示用户设置5分钟雨量超过该值为异常数据。</span>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="diagShowRain = false">取消</el-button>
            <el-button type="primary" @click="onSaveRain">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import accountTypes from '@/store/types/account'
export default {
  data () {
    return {
      height: 10,
      tdata: [],
      loading: false,
      diagShowWater: false,
      diagTitleWater: '水位值设置',
      diagShowRain: false,
      diagTitleRain: '雨量值设置',
      query: {
        searchName: '',
        pageIndex: 1,
        pageSize: 20
      },
      waterForm: {},
      rainForm: {},
      waterRules: {
        waterValue: [{ required: true, message: '水位值不能为空' }]
      },
      rainRules: {
        rainValue: [{ required: true, message: '雨量值不能为空' }]
      },
      multipleSelection: []
    }
  },
  methods: {
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.multipleSelection = JSON.parse(JSON.stringify(val))
    },
    onLoadData () {
      this.loading = true
      // this.$store
      //   .dispatch(accountTypes.GET_ROLES, {
      //     roleGroupId: this.query.roleGroupId,
      //     searchName: this.query.searchName
      //   })
      //   .then((data) => {
      //     this.total = data.total
      //     this.roles = data.results
      //     this.allRoles = data.results
      //     this.loading = false
      //   })
    },
    exportExcel () {
      // this.$store
      //   .dispatch(accountTypes.EXPORT_PERSONLIST, {
      //     personName: this.query.personName,
      //     adcdList: adcdList,
      //     position: this.query.personPosition,
      //     pageIndex: this.query.pageIndex,
      //     pageSize: this.query.pageSize
      //   })
      //   .then(data => {
      //     window.open(`${config.ApiYJ}${data.data}`)
      //     this.loading = false
      //   })
    },
    onConfigWater (type) {
      this.diagShowWater = true
      this.waterForm = {}
      this.$store
        .dispatch(accountTypes.GET_ABNORMAL_VAVAL, {
          Type: type
        })
        .then((data) => {
          this.waterForm.waterValue = data.detail
        })
    },
    onConfigRain (type) {
      this.diagShowRain = true
      this.rainForm = {}
      this.$store
        .dispatch(accountTypes.GET_ABNORMAL_VAVAL, {
          Type: type
        })
        .then((data) => {
          this.rainForm.rainValue = data.detail
        })
    },
    onSaveRain () {
      this.$refs['rainForm'].validate((valid) => {
        if (valid) {
          // this.loading = true
          // this.$store
          //   .dispatch(accountTypes.SAVE_ROLE, currentRole)
          //   .then(() => {
          //     this.loading = false
          //     this.diagShow = false
          //     this.$notify.success({ title: '成功', message: '保存角色成功.' })
          //     this.query.roleGroupId = currentRole.roleGroupId
          //     this.onLoadData()
          //   })
          //   .catch(() => {
          //     this.loading = false
          //   })
        }
      })
    },
    onSaveWater () {
      this.$refs['waterForm'].validate((valid) => {
        if (valid) {
          // this.loading = true
          // this.$store
          //   .dispatch(accountTypes.SAVE_ROLE, currentRole)
          //   .then(() => {
          //     this.loading = false
          //     this.diagShow = false
          //     this.$notify.success({ title: '成功', message: '保存角色成功.' })
          //     this.query.roleGroupId = currentRole.roleGroupId
          //     this.onLoadData()
          //   })
          //   .catch(() => {
          //     this.loading = false
          //   })
        }
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', {
          name: this.$route.meta,
          type: this.$route.name
        })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', {
      name: this.$route.meta,
      type: this.$route.name
    })
    this.onLoadData()
  },
  mounted () {
    this.$nextTick(() => {
      let selectDiv = document.getElementsByClassName('select')
      this.height =
        this.$refs['skt'].offsetHeight - 20 - selectDiv[0].offsetHeight
    })
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.usercenterUnusualDataReport {
  .formContent {
    display: flex;
    justify-content: space-between;
    /deep/ .el-form-item {
      width: 98%;
    }
  }
   #export{
    padding: 8px 8px;
    background-color: #3e81fc;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    font-size:16px;
     &:hover{
      background-color: #4d8cff;
    }
    .export-icon{
      width: 18px;
      height: 17px;
      display: inline-block;
      background-image: url('~@/assets/monitorimg/export.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 5px;
  }
  }
   #setRain{
    padding: 9px 9px;
    background-color: #44AA44;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    font-size:16px;
     &:hover{
      background-color: #67c23a;
    }
      .setRain-icon{
      width: 18px;
      height: 17px;
      display: block;
      background-image: url('~@/assets/monitorimg/edit.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 5px;
      float: left;
      margin-top: 2px;
    }
  }
   #setWater{
    padding: 9px 9px;
    background-color: #27b6e2;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    font-size:16px;
     &:hover{
      background-color: #12a0cc;
    }
      .setWater-icon{
        width: 18px;
        height: 17px;
        display: block;
        background-image: url('~@/assets/monitorimg/edit.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-right: 5px;
        float: left;
        margin-top: 2px;
    }
  }
}
</style>
